<div class="container-fluid glb-popup">
  <h2>{{ formTitle }}</h2>
  <p-toast [style]="{ marginTop: '80px' }"> </p-toast>
  <button
    mat-icon-button
    [mat-dialog-close]="true"
    style="float: right; top: -50px; background-color: transparent"
    >
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr />
  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">
      <div class="col-lg-12">
        @if (formAlert) {
          <div class="w-100 mb-3">
          <div class="w-100" style="
              text-align: center;
              background-color: yellow;
              padding: 5px;
              margin-bottom: 15px;
            ">
              <p>
                <b>{{ formAlert }}</b>
              </p>
            </div>
          </div>
        }
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-4">
          @if (proformaList?.length > 0) {
            <p-dropdown [options]="proformaList"
              formControlName="proformaId" optionLabel="customOption"
              optionValue="proformaId" (onChange)="onSelectProforma($event)"
              [filter]="true" filterBy="name" [showClear]="false"
              placeholder="Copy Proforma From">
            </p-dropdown>
          }
          <label for="Copy Proforma From">Copy Proforma From</label>
          <span>
            @if (proformaNotSelected) {
              <small class="p-invalid"
                >Please Select Proforma to be copied.
              </small>
            }
          </span>
        </span>
      </div>

      <div class="row d-flex justify-content-between">
        <div class="col-11 row py-0">
          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-4">
              <p-dropdown [options]="mktgLetters"
                formControlName="mktgLetterId" appendTo="body" optionLabel="adrDevelopmentName"
                optionValue="mktgLetterId" (onChange)="changeMktgLetter($event)"
                [filter]="true" filterBy="adrDevelopmentName" [showClear]="false"
                placeholder="Select Marketing Letter" >
              </p-dropdown>
              <label for="Select Marketing Letter">Select Marketing Letter</label>
              <span>
                @if (letterNotSelected) {
                  <small class="p-invalid"
                    >Please Select Marketing Letter.
                  </small>
                }
              </span>
            </span>
          </div>
        </div>
        <div class="col-1 py-0 d-flex justify-content-end align-items-center">
          @if (form1.controls['mktgLetterId'].value) {
            <button class="btn btn-icon mb-4" (click)="formEditMktgLetter()">
              <i class="pi pi-pencil" aria-hidden="true" style="color:blue;"></i>
            </button>
          }
        </div>
      </div>
      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="senderName" id="senderName" type="text" pInputText/>
          <label for="senderName">Sender Name</label>

          @for (validation of validationMessages.senderName; track validation) {
            <span>
              @if (form1.get('senderName').hasError(validation.type) && (form1.get('senderName').dirty || form1.get('senderName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="senderEmail" id="senderEmail" type="text" pInputText/>
          <label for="name">Sender Email</label>

          @for (validation of validationMessages.senderEmail; track validation) {
            <span>
              @if (form1.get('senderEmail').hasError(validation.type) && (form1.get('senderEmail').dirty || form1.get('senderEmail').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <!-- <p-inputMask formControlName="senderMobile" id="senderMobile" mask="(999) 999-9999" type="text">
        </p-inputMask> -->
        <input formControlName="senderMobile" id="senderMobile" type="text" pInputText>
        <label for="senderMobile">Sender Mobile Number</label>
        @for (validation of validationMessages.senderMobile; track validation) {
          <span>
            @if (form1.get('senderMobile').hasError(validation.type) && (form1.get('senderMobile').dirty || form1.get('senderMobile').touched)) {
              <small class="p-invalid"
                >{{validation.message}}
              </small>
            }
          </span>
        }
      </span>
    </div>
  </div>
</div>
<hr />

<div>
  <h3>Filter Recipients</h3>

  <p-checkbox class="ms-3 me-2 my-1" (onChange)="updateTableStatus('owner-lead-profile',$event)" [formControl]="form1.controls['ownerLeadProfile']" inputId="ownerLeadProfile"
  [binary]="true"></p-checkbox>
  <label class="property-icon-wapper" for="ownerLeadProfile">Owner Lead Profile</label>
  <p-checkbox class="ms-3 me-2 my-1" (onChange)="updateTableStatus('property-lead-profile',$event)" [formControl]="form1.controls['propertyLeadProfile']" inputId="propertyLeadProfile"
  [binary]="true"></p-checkbox>
  <label class="property-icon-wapper" for="propertyLeadProfile">Property Lead Profile</label>
  <div class="mt-2">
    <app-search-template searchLabel="Generate Proformas" [showSearchButton]=true [reset]=true [showLocations]=false [showDevelopments]=false
      [showShortTermRentals]=false [showRateBuckets]=false  [showBedrooms]=false [showSeasons]=false [showSaleDateStart]=false [showSubjAdrCity] ="true"
      [showSaleDateEnd]=false [showHoldDateStart]=false [showHoldDateEnd]=false [showHoldExpiredDateStart]=false [showHoldExpiredDateEnd]=false [showJobLevel]="true"
      [showCheckInDateStart]=false [showCheckInDateEnd]=false [showCheckOutDateStart]=false [showCheckOutDateEnd]=false [showCancelDateStart]=false [showJobCategories]="true"
      [guestMasterProfile]="false" [ownerLeadProfile]="ownerLeadProfile" [propertyLeadProfile]="propertyLeadProfile" [showOwnerListingStatus]="true"
      [employeeProfile]="false" [ownerProfile]="false" [guestProfile]="false" [showSubjAdrState]="true" [showSubAdrDevelopmentName]="true" [showSubAdrCity]="true"
      [realtorProfile]="false" [contacts]="false" [showSubAdrIsland]="true" [showOwnerLeadListingStatus]="true" [showCancelDateEnd]=false [showFutureGuestDate]=false
    [showReservationStatus]=false [showExcludeFutureGuests]="false" [parentId]="" (doSearchCB)="onSearchSubmit($event)"></app-search-template>
  </div>

</div>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}
<hr />
<app-proforma-generated-list [updateProformaList]="updateProformaList" [proformaList]="proformas"></app-proforma-generated-list>
<div class="row m-0">
  <div class="col-lg-12">
    <div class="btn-group">
      <div class="button-group">
        <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
        @if (proformas?.length > 0) {
          <button pButton class="btn-upt p-button" (click)="sendProforma()">Send</button>
        }
      </div>
    </div>
  </div>
</div>
</div>
